import styles from './PlacingOrderList.module.scss';
import PlacingOrderListItem from '../PlacingOrderListItem/PlacingOrderListItem';
import { TPlacingOrderListItem, TPlacingOrderListProps } from '../../types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const PlacingOrderList: React.FC<TPlacingOrderListProps> = (props: TPlacingOrderListProps): React.ReactElement => {
  const { parcels } = props;

  const [numberOfVisibleItems, setNumberOfVisibleItems] = useState<number>(8);

  const { t } = useTranslation();

  return (
      <>
        <ul className={styles.list}>
          {parcels.map((item: TPlacingOrderListItem, index: number) => {
            if (parcels.length === numberOfVisibleItems || index < numberOfVisibleItems) {
              return (
                  <PlacingOrderListItem
                      key={index}
                      {...item}
                  />
              );
            }
          })}
        </ul>
        {parcels.length > numberOfVisibleItems && (
            <button
                className={styles.action}
                onClick={() => setNumberOfVisibleItems(parcels.length)}
            >
              {`+ ${t('placingOrderView.list.more')} ${(parcels.length - numberOfVisibleItems)}`}
            </button>
        )}
      </>
  );
};

export default PlacingOrderList;